//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import { EVENTS, STATIC_HEADER, RB_APP__HEADER } from '@/scripts/constants/css-classes'
import wcs from '@/scripts/libs/wcs'
const { viewTaskName, pagesWithStickyStoriesSlider } = wcs.getStoreConfig()

export default {
  name: 'rb-stories-slider',

  props: {
    isScrollEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      defaultConfig: {
        freeMode: true,
        slidesPerView: 'auto',
        initialSlide: this.initialSlide,
      },
      dataScroll: {
        currentScroll: 0,
        storiesOffset: 0,
        cloneOffset: 0,
        headerHeight: 0,
        storiesHeight: 0,
        isFixed: false,
        scrollDirection: '',
        lastScroll: 0,
        downOffset: 0,
        upOffset: 0,
        safeZone: 10,
      },
    }
  },
  computed: {
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
    isSmallImages() {
      return this.dataScroll.scrollDirection == 'down' ? 'rb-stories-background--small' : ''
    },
    storiesFixed() {
      return this.dataScroll.isFixed ? 'rb-stories-background--fixed' : ''
    },
    setOffset() {
      return this.dataScroll.isFixed ? this.dataScroll.headerHeight + 'px' : 'auto'
    },
    setHeight() {
      return this.dataScroll.isFixed ? this.dataScroll.storiesHeight + 'px' : '0'
    },
  },
  beforeDestroy() {
    window.removeEventListener(EVENTS.SCROLL, this.setScroll)
  },
  mounted() {
    const storiesList = this.$slots.default

    if (storiesList) {
      this.setWidthElements(storiesList[0].elm.parentElement, storiesList)
    }
    if (this.isScrollEnabled || pagesWithStickyStoriesSlider.includes(viewTaskName)) {
      window.addEventListener(EVENTS.SCROLL, this.setScroll)
    }
    const storiesMargin = parseInt(
      window
        .getComputedStyle(this.$refs.storiesContainer.$el, null)
        .getPropertyValue('margin-bottom')
    )
    this.dataScroll.storiesHeight = this.$refs.storiesContainer.$el.offsetHeight + storiesMargin
    this.$slots.default.forEach((slot) => {
      if (slot.elm && slot.elm.classList) {
        slot.elm.classList.remove('loading')
      }
    })
    this.checkStaticHeader()
    window.dispatchEvent(new Event('resize'))
  },
  methods: {
    setWidthElements(container, elements) {
      const widthWindow = document.body.clientWidth
      let summWidthItems = 0
      const numberSlidesForDesktop = 8
      const numberSlidesForTabletAndMobile = 3
      const numberSlidesForDesktopWillShow = 6.5
      const numberSlidesForTabletAndMobileWillShow = 2.5
      for (let el of elements) {
        if (el.elm.offsetWidth) {
          summWidthItems += el.elm.offsetWidth
        }
      }
      if (
        elements.length >= numberSlidesForDesktop &&
        !(this.$mq === MOBILE || this.$mq === TABLET)
      ) {
        const widthItem = widthWindow / numberSlidesForDesktopWillShow
        for (let el of elements) {
          if (el.elm && el.elm.style) {
            el.elm.style.width = `${widthItem}px`
          }
        }
      } else if (
        elements.length >= numberSlidesForTabletAndMobile &&
        (this.$mq === MOBILE || this.$mq === TABLET)
      ) {
        const widthItem = widthWindow / numberSlidesForTabletAndMobileWillShow
        for (let el of elements) {
          if (el.elm && el.elm.style) {
            el.elm.style.width = `${widthItem}px`
          }
        }
      } else if (widthWindow > summWidthItems) {
        container.classList.add('rb-stories-swiper--justify')
      }
    },
    setScroll() {
      this.defineFixed()
      this.checkStaticHeader()
      this.defineDirection()
    },
    checkStaticHeader() {
      let appHeader = document.getElementsByClassName(RB_APP__HEADER)[0]
      if (!appHeader?.classList.contains(STATIC_HEADER)) {
        this.dataScroll.headerHeight = appHeader.offsetHeight
      }
    },
    defineFixed() {
      this.dataScroll.currentScroll = window.pageYOffset || document.documentElement.scrollTop
      this.dataScroll.storiesOffset = this.$refs.storiesContainer.$el.getBoundingClientRect().top
      this.dataScroll.cloneOffset = this.$refs.cloneContainer.getBoundingClientRect().top
      if (this.dataScroll.isFixed) {
        this.dataScroll.isFixed =
          this.dataScroll.cloneOffset - this.dataScroll.headerHeight > 0
            ? false
            : this.dataScroll.isFixed
      } else {
        this.dataScroll.isFixed =
          this.dataScroll.storiesOffset - this.dataScroll.headerHeight <= 0
            ? true
            : this.dataScroll.isFixed
      }
    },
    defineDirection() {
      if (this.dataScroll.currentScroll > this.dataScroll.lastScroll) {
        this.dataScroll.upOffset = 0
        this.dataScroll.downOffset += this.dataScroll.currentScroll - this.dataScroll.lastScroll
      } else if (this.dataScroll.currentScroll < this.dataScroll.lastScroll) {
        this.dataScroll.downOffset = 0
        this.dataScroll.upOffset += this.dataScroll.lastScroll - this.dataScroll.currentScroll
      }
      if (this.dataScroll.isFixed) {
        if (this.dataScroll.downOffset >= this.dataScroll.safeZone) {
          this.dataScroll.scrollDirection = 'down'
        } else if (this.dataScroll.upOffset >= this.dataScroll.safeZone) {
          this.dataScroll.scrollDirection = 'up'
        }
      } else {
        this.dataScroll.scrollDirection = 'up'
      }
      this.dataScroll.lastScroll = this.dataScroll.currentScroll
    },
  },
}
